export default __webpack_public_path__ + "static/media/logo.c69970b5.png";